import React from 'react';
import portrait from '../assets/images/portrait.jpg';
import { Col, Container, Row } from 'react-bootstrap';
import PageBanner from './PageBanner';

const testimonials = [
    {
        id: 1,
        photo: portrait,
        client: "Dolor",
        msg: "Lorem ipsum dolor amet. Lorem ipsum dolor amet. Lorem ipsum.."
    },
    {
        id: 2,
        photo: portrait,
        client: "Dolor",
        msg: "Lorem ipsum dolor amet. Lorem ipsum dolor amet. Lorem ipsum.."
    },
    {
        id: 3,
        photo: portrait,
        client: "Dolor",
        msg: "Lorem ipsum dolor amet. Lorem ipsum dolor amet. Lorem ipsum.."
    },
    {
        id: 4,
        photo: portrait,
        client: "Dolor",
        msg: "Lorem ipsum dolor amet. Lorem ipsum dolor amet. Lorem ipsum.."
    },
]

const Testimonials = () => {
    return (
        <>
            <div className='testimonials'>
                <PageBanner msgLine2={"Testimonials"}/>
                <div className='text-testimonials'>
                    <Container>

                        {testimonials.map((item, ind) => {
                            return (
                                <>
                                    <div className='py-2'>
                                        <Row key={ind}>
                                            <Col xs={1}>
                                                <img src={item.photo} />
                                            </Col>
                                            <Col xs={11}>
                                                <div className='msg'>
                                                    <p>{item.msg}</p>
                                                    <h6>- {item.client}</h6>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </>
                            )
                        })}


                    </Container>
                </div>
            </div>
        </>
    )
}

export default Testimonials